import React from 'react';
import {
    Col, Container, Row,
} from 'reactstrap';
import { isNil } from 'lodash-es';
import { faMinusCircle } from '@fortawesome/free-solid-svg-icons';
import { getShort } from '@s20/common/util/date';
import CommonContext from '../Common';
import SlideForm from '../common/forms/SlideForm';
import ValidatedSelect from '../common/forms/ValidatedSelect';
import { NotAuthorizedPage } from '../status/StatusCodes';
import { PriceDisplay } from '../common/PriceDisplay';

export default class BillingRateHistoryForm extends React.Component {
    static contextType = CommonContext;

    constructor(props) {
        super(props);
        this.formRef = React.createRef();
        this.state = {
            loading: true,
            errors: {},
            formValidated: false,
            validationMessage: '',
            isValidated: false,
        };
    }

    componentDidMount() {
        this.populateState();
    }

    onClose = (response) => {
        this.resetForm();
        this.context.setFormOpened(false);
        this.props.onClose(response);
    };

    onRemove = () => {
        this.context.setFormOpened(false);
        this.props.onRemoveCallback();
    };

    onSubmit = () => {
        this.context.setFormOpened(false);
        this.props.onSaveCallback();
    };

    populateState() {
        this.setState({
            loading: false,
        });
    }

    resetForm = () => this.setState({ formValidated: false, errors: {} });

    render() {
        const { tenantSettings } = ((this.context ?? {}).tenant ?? {});

        if (!tenantSettings.billingRatesEnabled) return <NotAuthorizedPage />;

        if (!this.props.entity) return '';
        const { entity } = this.props;
        const name = (this.props.entityName ? `${this.props.entityName}.` : '');

        return (
            <SlideForm
                loading={this.state.loading}
                show={this.props.show}
                id="billingRateHistoryForm"
                formIcon={faMinusCircle}
                formTitle="Rate History"
                ref={this.formRef}
                setIsValidated={(value) => {
                    this.setState({ formValidated: value });
                }}
                isValidated={this.state.formValidated}

                onClose={this.onClose}
                errors={this.state.errors}
                onClearErrors={this.onClearErrors}
                error={this.state.validationMessage}
                showDelete={this.props.showRemove === true}
                onDelete={this.onRemove}
            >
                <>
                    {!!this.props.showChargeType == true
                        && (
                            <ValidatedSelect
                                className="ml-3 w-auto"
                                isClearable={false}
                                id={`${name}chargeTypeId`}
                                name={`${name}chargeTypeId`}
                                label="Charge"
                                required
                                value={this.props.chargeTypes.find((i) => i.value == entity.chargeTypeId) ?? ''}
                                options={this.props.chargeTypes ?? []}
                                onChange={this.props.onSelectChange}
                                getOptionLabel={(o) => o.label}
                                getOptionValue={(o) => o.value}
                                error="A charge is required."
                            />
                        )}
                    <Container
                        fluid
                        className="p-2"
                    >
                        <Row>
                            <Col className="ml-0 mr-0">
                                <table className="table table-sm table-bordered">
                                    <thead>
                                        <tr>
                                            {(this.props.showChargeType ?? {}) == true
                                                && <th style={{ width: '15%' }}>Charge Type</th>}
                                            <th style={{ width: '15%' }}>Rate</th>
                                            <th style={{ width: '15%' }}>Overtime Rate</th>
                                            <th style={{ width: '15%' }}>Alternative Rate</th>
                                            <th style={{ width: '20%' }}>Effective Date</th>
                                            <th style={{ width: '20%' }}>Expiration Date</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {!(entity ?? []).length
                                            ? (
                                                <tr>
                                                    <td
                                                        colSpan="9"
                                                        className="text-center"
                                                    >
                                                        No rates found.
                                                    </td>
                                                </tr>
                                            )
                                            : entity.map((rate) => (
                                                <tr key={rate.billingRateId}>
                                                    {(this.props.showChargeType ?? {}) == true
                                                        && (
                                                            <td>
                                                                {rate.chargeTypeName}
                                                            </td>
                                                        )}
                                                    <td>
                                                        {!isNil(rate.billingRate.rate) && <PriceDisplay amount={rate.billingRate.rate} />}
                                                    </td>
                                                    <td>
                                                        {!isNil(rate.billingRate.otRate) && <PriceDisplay amount={rate.billingRate.otRate} />}
                                                    </td>
                                                    <td>
                                                        {!isNil(rate.billingRate.altRate) && <PriceDisplay amount={rate.billingRate.altRate} />}
                                                    </td>
                                                    <td>
                                                        {!isNil(rate.billingRate.effectiveDate) && getShort(rate.billingRate.effectiveDate)}
                                                    </td>
                                                    <td>
                                                        {!isNil(rate.billingRate.expirationDate) && getShort(rate.billingRate.expirationDate)}
                                                    </td>
                                                </tr>
                                            ))}
                                    </tbody>
                                </table>
                            </Col>
                        </Row>
                    </Container>
                </>
            </SlideForm>
        );
    }
}
